import { aiPhotoGenerationPromoBannerShowConfig } from 'reactApp/appHelpers/featuresHelpers/features/aiPhotoGeneration';
import { getItemFromLocalStorage, setItemFromLocalStorage } from 'reactApp/appHelpers/localstorageHelpers';
import type { Dispatch } from 'redux';

type GetState = () => any;

const LOCAL_STORAGE_KEY = 'ai-photo-generation-promo-banner-state' as const;

interface AiPhotoGenerationPromoBannerState {
    closeCount: number;
    lastClosedAt: number;
}

export const getAiPhotoGenerationPromoBannerHidden =
    () =>
    (dispatch: Dispatch, getState: GetState): boolean => {
        const state = getItemFromLocalStorage<AiPhotoGenerationPromoBannerState>(LOCAL_STORAGE_KEY)(dispatch, getState);

        if (!state) {
            return false;
        }

        if (state.closeCount >= aiPhotoGenerationPromoBannerShowConfig?.showLimit) {
            return true;
        }

        return Date.now() - state.lastClosedAt < aiPhotoGenerationPromoBannerShowConfig?.showInterval;
    };

export const setAiPhotoGenerationPromoBannerHidden =
    () =>
    (dispatch: Dispatch, getState: GetState): void => {
        const state = getItemFromLocalStorage<AiPhotoGenerationPromoBannerState>(LOCAL_STORAGE_KEY)(dispatch, getState);

        setItemFromLocalStorage<AiPhotoGenerationPromoBannerState>(LOCAL_STORAGE_KEY, {
            closeCount: (state?.closeCount ?? 0) + 1,
            lastClosedAt: Date.now(),
        })(dispatch, getState);
    };
